import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { Route } from 'react-router';
import TagManager from 'react-gtm-module';
import axios from 'axios';
import { tokenInterceptor } from '@prime/auth';
import App from './App';
import * as serviceWorker from './serviceWorker';
import i18n from './App/core/i18n/i18n';
import { APP_CONFIG } from './config/appConfig';
import { ROLES } from './App/core/auth/enums/roles';
import { ROUTES } from './App/core/router/routes';
import NotFound from './App/core/error/NotFound';
import AccessDenied from './App/core/error/AccessDenied';
import Unauthorized from './App/core/error/Unauthorized';
import Unavailable from './App/core/error/Unavailable';
import { rootStore } from './App/core/store/rootStore';
import AuthProvider from './App/core/auth/AuthProvider/AuthProvider';
import OAuthClient from './App/core/auth/AuthProvider/OAuthClient';
import ProtectedRoute from './App/core/router/ProtectedRoute';

const history = createBrowserHistory();
const tagManagerArgs = {
  gtmId: APP_CONFIG.GOOGLE_GTM_ID,
};

TagManager.initialize(tagManagerArgs);

axios.interceptors.request.use(tokenInterceptor(OAuthClient));

ReactDOM.render(
  <BrowserRouter>
    <Provider store={rootStore(history)}>
      <ConnectedRouter history={history}>
        <I18nextProvider i18n={i18n}>
          <Switch>
            <Route exact path={ROUTES.ERROR_401} component={Unauthorized} />
            <Route exact path={ROUTES.ERROR_403} component={AccessDenied} />
            <Route exact path="/articles/show/109">
              <Redirect to="/articles/show/373" />
            </Route>
            <AuthProvider OAuthClient={OAuthClient}>
              <Switch>
                <Route exact path={ROUTES.ERROR_404} component={NotFound} />
                <Route exact path={ROUTES.ERROR_503} component={Unavailable} />
                <ProtectedRoute
                  path={ROUTES.DEFAULT}
                  component={App}
                  allowedRoles={[ROLES.ROLE_ADMIN, ROLES.ROLE_USER]}
                />
              </Switch>
            </AuthProvider>
          </Switch>
        </I18nextProvider>
      </ConnectedRouter>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
